import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: '20px',
    },
    wrap: {
        marginBottom: 12, 
        width: '100%', 
        background: '#1b2039', 
        borderRadius: 4, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        padding: '20px 0',
    },
    flexColumn: {
        flexDirection: 'column'
    },
    title: {
        color: '#fff', 
        fontFamily: 'Montserrat, sans-serif', 
        fontSize: 18
    },
    p0: {
        padding: 0
    },
    mb12: {
        marginBottom: 12
    },
    search: {
        padding: 10,
        background: '#141b33',
        border: '1px solid #141b33',
        borderRadius: 4,
        color: '#fff',
        outline: 'none',
        width: 'calc(100% - 20px)'
    },
    wrapBlock: {
        padding: '10px', 
        marginBottom: 12, 
        width: 'calc(100% - 20px)', 
        background: '#1b2039', 
        borderRadius: 8, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        flexDirection: 'column'
    },
}))

export {
    useStyles
}